import React from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import InputComponent from '../elements/input';
import FIELDS from '../../data/fields';

import { loadSettings, updateSettings } from '../../app/store/actions/settings';

class SocialMediaComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      social: props.social,
      message: '',
      success: '',
    };
  }

  setInput = async (attr, val) => {
    const { social } = this.state;
    social[attr] = val;
    await this.setState(social);
  }

  uploadedFile = async () => {
    const {
      socialFacebook, socialTwitter, socialLinkedin, socialInstagram,
    } = this.state;
    try {
      await this.props.updateSettings({
        socialFacebook, socialTwitter, socialLinkedin, socialInstagram,
      });
      await this.setState({ message: '', success: I18n.t('saved') });
    } catch (err) {
      await this.setState({ message: I18n.t('errorOcurred'), success: '' });
    }
  }

  render() {
    const {
      socialFacebook, socialTwitter, socialLinkedin, socialInstagram,
    } = this.state.social;
    const { message, success } = this.state;
    return (
      <div>
        <p>Links:</p>
        <InputComponent
          type="text"
          className="form-control"
          placeHolder="Facebook"
          onChange={e => this.setInput('socialFacebook', e.target.value)}
          value={socialFacebook}
          maxLength={FIELDS.max}
        />
        <InputComponent
          type="text"
          className="form-control"
          placeHolder="Twitter"
          onChange={e => this.setInput('socialTwitter', e.target.value)}
          value={socialTwitter}
          maxLength={FIELDS.max}
        />
        <InputComponent
          type="text"
          className="form-control"
          placeHolder="Linkedin"
          onChange={e => this.setInput('socialLinkedin', e.target.value)}
          value={socialLinkedin}
          maxLength={FIELDS.max}
        />
        <InputComponent
          type="text"
          className="form-control"
          placeHolder="Instagram"
          onChange={e => this.setInput('socialInstagram', e.target.value)}
          value={socialInstagram}
          maxLength={FIELDS.max}
        />
        <button
          onClick={() => this.uploadedFile()}
          type="button"
          className="btn btn-secondary margin-bottom-20"
        >
          <Translate value="save" />
        </button>
        {success && <p className="color-green margin-top-10">{success}</p>}
        {message && <p className="color-red margin-top-10">{message}</p>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  social: state.settings,
});

const mapDispatchToProps = dispatch => ({
  loadSettings: dispatch(loadSettings()),
  updateSettings: settings => dispatch(updateSettings(settings)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SocialMediaComponent);
